const LangEgiftCardVerifyEgift = {
	"egiftCardVerifyEgift.verifyEgift": ["Verify E-Gift", "Xác nhận quà tặng"],
	"egiftCardVerifyEgift.pleaseEnterYourEmailAddress": [
		"Please Enter Your E-Mail Address",
		"Vui lòng nhập email của bạn",
	],
	"egiftCardVerifyEgift.starbucksCardNumber": ["Starbucks Card Number", "Số thẻ"],
	"egiftCardVerifyEgift.yourEgiftHasBeenExpiredAndCannotBeUsed": [
		"Your E-gift has been expired and can not be used.",
		"Rất tiếc, thẻ quà tặng của bạn đã bị hết hạn và không thể sử dụng.",
	],
	"egiftCardVerifyEgift.yourEgiftHasBeenExpiredPleaseContactSupport": [
		"Your E-gift has been expired, please contact our Customer Care Center at (028) 7306 7676 for support.",
		"Thẻ quà tặng của bạn đã bị hết hạn. Vui lòng liên hệ Trung Tâm Thẻ tại (028) 7306 7676 để được hỗ trợ.",
	],
	"egiftCardVerifyEgift._consentAgreementRules": [
		"By clicking this button, I agree to the Starbucks Site&nbsp;",
		"Bằng cách bấm nút bên dưới, tôi đã đọc và đồng ý với Starbucks&nbsp;",
	],
	"egiftCardVerifyEgift._consentAgreementRules2": ["&nbsp;", "&nbsp;chương trình"],
	"egiftCardVerifyEgift._termOfUse": ["Terms of Use", "Điều kiện điều khoản"],
	"egiftCardVerifyEgift._termOfUseLink": [
		"https://en.starbucks.vn/about-us/company-information/online-policies/starbucks-rewards-terms-and-conditions",
		"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty/ch%C3%ADnh-s%C3%A1ch-tr%E1%BB%B1c-tuy%E1%BA%BFn/starbucks-rewards-terms-and-conditions",
	],
	"voucherBundle.title": [
		"Redeem Starbucks® voucher bundle",
		"Đổi gói phiếu thưởng Starbucks®",
	],
	"voucherBundle.contentTitle": [
		"Oops, seems like you don't have a Starbucks®️ Vietnam app.",
		"Rất tiếc, có vẻ như bạn không có ứng dụng Starbucks®️ Việt Nam.",
	],
	"voucherBundle.content.subTitle": [
		"Please download the Starbucks Vietnam app from App Store or Play Store and register as a member with us.",
		"Vui lòng tải ứng dụng Starbucks Việt Nam từ App Store hoặc Play Store và đăng ký thành viên với chúng tôi.",
	],
	"voucherBundle.content.bottomTitle": [
		"Once you're logged in to our app, return to the email to start the redemption process.",
		"Khi bạn đã đăng nhập vào ứng dụng của chúng tôi, hãy quay lại email để bắt đầu quá trình mua lại.",
	],
	"voucherBundle.content.call.hotline": ["Contact hotline", "Gọi đường dây nóng"],
	"voucherBundle.verify.egift": ["Verify Email", "Xác minh Email"],
}

export default LangEgiftCardVerifyEgift
